export default "__VITE_PUBLIC_ASSET__5474177e__"